import { useMemo } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import TrustBar from "@/pages/home/components/TrustBar";
import Services from "@/pages/home/components/Services";
import PromoBanner from "@/pages/home/components/PromoBanner";
import Attractions from "@/pages/home/components/Attractions";
import Fleet from "@/pages/home/components/Fleet";
import JetSki from "@/pages/home/components/JetSki";
import SplashDeck from "@/pages/home/components/SplashDeck";
import OffRoad from "@/pages/home/components/OffRoad";
import GoogleReviews from "@/pages/home/components/GoogleReviews";
import BoardingPoint from "@/pages/home/components/BoardingPoint";
import About from "@/pages/home/components/About";
import WhyChoose from "@/pages/home/components/WhyChoose";
import Faq, { FAQ_ITEMS } from "@/pages/home/components/Faq";
import CtaSection from "@/pages/home/components/CtaSection";
import Footer from "@/pages/home/components/Footer";
import Seo from "@/components/feature/Seo";
import { buildFaqSchema, homeWebPageSchema } from "@/seo/schema";
import { SITE_URL } from "@/pages/home/constants";
import { useReveal } from "@/hooks/useReveal";

export default function Home() {
  useReveal();

  const jsonLd = useMemo(() => {
    const faqSchema = buildFaqSchema(
      FAQ_ITEMS.map((item) => ({ question: item.question, answer: item.answer })),
    );
    return [homeWebPageSchema, faqSchema];
  }, []);

  return (
    <main className="min-h-screen bg-background-50 overflow-x-hidden">
      <Seo
        title="Passeio de Lancha em Capitólio | Eco Tour Turismo"
        description="Passeios de lancha em Capitólio no Lago de Furnas com conforto e segurança. Compartilhados, exclusivos, aluguel de lancha e jet ski. Reserve pelo WhatsApp."
        keywords="passeio de lancha em Capitólio, passeios de lancha em Capitólio, aluguel de lancha em Capitólio, locação de lancha em Capitólio, passeios náuticos em Capitólio, passeio no Lago de Furnas, jet ski em Capitólio, Mar de Minas"
        canonical={SITE_URL}
        jsonLd={jsonLd}
      />
      <Navbar />
      <Hero />
      <TrustBar />
      <Services />
      <PromoBanner />
      <Attractions />
      <Fleet />
      <JetSki />
      <SplashDeck />
      <OffRoad />
      <GoogleReviews />
      <BoardingPoint />
      <About />
      <WhyChoose />
      <Faq />
      <CtaSection />
      <Footer />
    </main>
  );
}